import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { useSeo } from "@/lib/seo";
import { WhatsAppAdvice } from "@/components/site/Conversion";

const POINTS = [
  ["La marque, en direct", "Vous achetez chez Ozentya, la marque : pas d'intermédiaire entre nos soins et vous."],
  ["Pensé pour les cheveux afro", "Cheveux crépus, frisés, naturels, locks, barbe et cuir chevelu : nos soins sont conçus pour ces besoins."],
  ["Abonnements Duo et Famille", "2 soins au choix pour 19,99 € ou 4 soins pour 39,90 € par mois. Sans engagement."],
  ["Un diagnostic gratuit", "Quelques questions pour trouver la routine adaptée à vos cheveux en une minute."],
  ["Un conseil sur WhatsApp", "Une question sur un soin ou une routine ? Écrivez-nous, c'est gratuit."],
  ["Livraison Point Relais offerte", "En France via Mondial Relay, et Colissimo à domicile, y compris dans les DOM-TOM."],
];

export default function WhyOzentya() {
  useSeo({ title: "Pourquoi choisir Ozentya pour vos cheveux afro, crépus et locks", description: "Soins Ozentya en direct de la marque : abonnement Duo 2 soins pour 19,99 €/mois, diagnostic gratuit, conseil sur WhatsApp, livraison Point Relais offerte.", path: "/pourquoi-ozentya" });
  return (
    <main data-testid="why-page" className="mx-auto max-w-5xl px-5 pb-24 pt-40 md:px-10">
      <p className="eyebrow mb-4">Pourquoi Ozentya</p>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl">Vos soins afro, <span className="italic gold-text">en direct de la marque</span></h1>
      <ul className="mt-12 grid gap-4 sm:grid-cols-2">
        {POINTS.map(([t, d]) => <li key={t} className="rounded-sm border border-[var(--line)] bg-[var(--ink-2)] p-6"><p className="flex items-center gap-2 font-semibold"><Check className="h-4 w-4 text-[var(--gold)]" />{t}</p><p className="mt-2 text-sm text-[var(--parchment)]/85">{d}</p></li>)}
      </ul>
      <div className="mt-12 flex flex-wrap items-center gap-4">
        <Link to="/diagnostic" data-testid="why-cta-diagnostic" className="inline-flex h-12 items-center gap-2 rounded-full bg-[var(--gold)] px-6 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--ink)] hover:bg-[var(--gold-soft)]">Faire mon diagnostic <ArrowRight className="h-4 w-4" /></Link>
        <Link to="/abonnement" data-testid="why-cta-subscription" className="inline-flex h-12 items-center gap-2 rounded-full border border-[var(--gold)] px-6 text-xs font-semibold uppercase tracking-[0.18em] text-[var(--gold-soft)]">Voir les abonnements</Link>
        <WhatsAppAdvice />
      </div>
    </main>
  );
}
